var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "msDrawer",
      attrs: {
        "append-to-body": "",
        withHeader: false,
        "show-close": false,
        size: "450px",
        visible: _vm.drawerMsg,
        "destroy-on-close": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawerMsg = $event
        },
        closed: function ($event) {
          return _vm.drawerMsgClose(false)
        },
      },
    },
    [
      _c("div", { staticClass: "msNotice" }, [
        _c("div", { staticClass: "msTitle" }, [_vm._v("消息通知")]),
        _vm.msList.length > 0
          ? _c(
              "div",
              { staticClass: "msList" },
              _vm._l(_vm.msList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "msItem",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.updateMessageRead(item)
                      },
                    },
                  },
                  [
                    _c("p", { staticClass: "tit tit-01" }, [
                      _vm._v(_vm._s(item.companyName)),
                    ]),
                    _c("div", { staticClass: "tit clearfix" }, [
                      _c(
                        "p",
                        {
                          staticClass: "tit-02",
                          attrs: { title: item.content },
                        },
                        [_vm._v(_vm._s(item.content))]
                      ),
                      _c("span", { staticClass: "time" }, [
                        _vm._v(_vm._s(item.pushTime)),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            )
          : _c("div", { staticClass: "empty" }, [
              _c("img", {
                attrs: { src: require("@/assets/subscribe/empty.png") },
              }),
              _c("p", { staticClass: "center" }, [_vm._v("暂无消息")]),
            ]),
      ]),
      _c(
        "div",
        { staticClass: "drawer_footer" },
        [
          _vm.pageMsg.total
            ? _c("pagination-msg", {
                key: _vm.pageMsg.pageNum,
                attrs: {
                  pageNum: _vm.pageMsg.pageNum,
                  pageSize: _vm.pageMsg.pageSize,
                  total: _vm.pageMsg.total,
                },
                on: {
                  sizeChange: _vm.handleSizeChange,
                  currentChange: _vm.handleCurrentChange,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }